import {
  Button,
  ButtonVariant,
  Checkbox,
  Panel,
  SideDrawer,
  ValidationWrapper,
} from "@/components";
import styles from "./styles.scss";
import { FC, Fragment, useState } from "react";
import { ANIMATION_DURATION } from "@/constants/drawer";
import { getApplicationRoot } from "@/utils";
import { AcknowledgementsProps } from "@/components/acknowledgement/types";
import { selectRequestFormStore, useBoundStore } from "@/services";

export const Acknowledgements: FC<AcknowledgementsProps> = ({
  acknowledgements,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { isAcknowledged, setIsAcknowledged } = useBoundStore(
    selectRequestFormStore,
  );

  return (
    <>
      <Panel header="Acknowledgements">
        <ValidationWrapper>
          <Checkbox
            checked={isAcknowledged}
            onChange={() => setIsAcknowledged(!isAcknowledged)}
          >
            <span>I acknowledge that I have read and accepted </span>
            <Button
              variant={ButtonVariant.Link}
              className={styles.buttonLink}
              onClick={() => setIsModalOpen(true)}
            >
              {" "}
              Terms and Conditions
            </Button>
          </Checkbox>
        </ValidationWrapper>
      </Panel>
      <SideDrawer
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        closeTimeoutMS={ANIMATION_DURATION}
        appElement={getApplicationRoot()}
        title={"Terms and Conditions"}
        onRequestClose={() => setIsModalOpen(false)}
        onClose={() => setIsModalOpen(false)}
      >
        <div className={styles.modalContent}>
          {acknowledgements?.map(
            ({ AcknowledgementDescEn = "", ApplicationActionId }) => {
              return (
                <Fragment key={ApplicationActionId}>
                  <div
                    className={styles.modalText}
                    dangerouslySetInnerHTML={{ __html: AcknowledgementDescEn }}
                  />
                </Fragment>
              );
            },
          )}
        </div>
      </SideDrawer>
    </>
  );
};
